import { useState, useEffect, useRef } from 'react'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BreadCrumb, CustomTable, SnackSimple } from '../../../../components'
import { Types } from '../../../../utils/enums'
import { Item, ObjectGeneric, onChange } from '../../../../utils/types/generals'
import { initialData, initialValues, modelOption, option, input, formatFilterMainOption } from './initialState'
import { getList, handleErrors, submit } from './methods'
import Form from './components/form'
import { useContextState } from '../../../../hooks/theme'
import { useStyles } from './style'
import { ModelOption } from './types'
import { icons } from '../../../../utils/icons'
import { httpFetch } from '../../../../utils/crud'
import { OptionGroupService } from '../../../../service/optionGroup'
import { OptionGroupList,  OptionTableRow } from '../../../../service/optionGroup/reponse'
import SimpleModal from '../../../../components/modal/simpleModal'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import { DinamicForm } from '../../../../components/dinamicForm'
import { InputModel } from '../../../../utils/types/inputModel'
import { getPreviousYears, monthYear } from '../../../../utils/constants/date_month'
import { useFilter } from '../../../../hooks/filter'
import { useDownload } from '../../../../hooks/download/useDownload'
import { returnQuery, returnQueryWithPagination } from '../../../../utils/methods/returnQuery'
import { ModelDownloadButtons } from '../../../../components/donwloadFiles/model'

const OptionGroup = () => {
  const { t } = useTranslation()
  const { colors } = useContextState()
  const [goForm, setGoForm] = useState(false)
  const styles = useStyles(colors, goForm)
  const [id, setId] = useState<number | null>(null)
  const [inputs, setInputs] = useState<{ [x: string]: InputModel }>(input)
  const [data, setData] = useState<ObjectGeneric>(initialData)
  const [btnLoading, setBtnLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [allErrors, setAllErrors] = useState<ObjectGeneric>({})
  const [table, setTable] = useState<OptionTableRow[]>([])
  const refTime = useRef<NodeJS.Timeout | null>(null)
  const filterMain = useFilter({ formatFilter: formatFilterMainOption })
  const { counter, errors, filterData, paginationModel, handlePagination, onChange, cleanFilter, sortTable, query, filterString } = filterMain
  const [totalPages, setTotalPages] = useState(0)
  const [openDeleteModal, setOpenDeleteModal] = useState({
    open: false,
    id: null,
  })
  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    openModal: false,
    message: '',
    type: Types.SUCCESS,
  })

  const handleCloseSnackbar = (value: boolean) => {
    setOpenSnackbar((prev) => ({ ...prev, open: value }))
  }
  const crudChange: onChange = (e, id): void => {
    const { name, value } = e?.target
    let body = { ...data }

    if (!!id && typeof id === 'number') {
      body = {
        ...body,
        options: body?.options?.map((item: any) => {
          if (item.id === id) {
            return {
              ...item,
              [name]: value,
            }
          } else {
            return item
          }
        }),
      }
    } else {
      body = {
        ...body,
        [name]: value,
      }
    }

    setData(body)
    setAllErrors(handleErrors(body, t))
  }

  const downloadMain = useDownload({
    docName: t('optionGroup.filter.title'),
    query: returnQueryWithPagination({ filter: filterString, sort: query?.sort, }).replace('&', ''),
    downloadFuntion: OptionGroupService(httpFetch).downloadFile,
  })

  const column: any[] = [
    {
      id: 'name',
      label: t('general.tags.name'),
      sortable: true,
    },
    {
      id: 'optionsCount',
      label: t('general.tags.optionNumber'),
      sortable: true,
    },
    {
      id: 'createTime',
      label: t('general.tags.startDate'),
      sortable: true,
    },
    {
      id: 'action',
      label: t('general.tags.action'),
    },
  ]

  const addOption = (id?: number) => {
    if (!id) {
      setData((prev) => ({
        ...prev,
        options: [...prev.options, { ...modelOption, id: prev.optionId + 1 }],
        optionId: prev.optionId + 1,
      }))
    } else {
      if (data.options?.length > 2) {
        setData((prev) => ({
          ...prev,
          options: prev.options?.filter((item: ModelOption) => item.id !== id),
        }))
      }
    }
  }

  const handleSubmit = async (removeId?: boolean) => {
    setBtnLoading(true)
    const response = await submit(data, t, removeId ? null : id)
    if (!response?.response?.response.errors) {
      getAll()
    } else {
      setData(response?.response?.copyData)
    }
    setOpenSnackbar(() => ({ ...response.snackbarBody }))
    setBtnLoading(false)
  }

  const handleDelete = async () => {
    if (openDeleteModal.id) {
      const response: any = await OptionGroupService(httpFetch).deleteOptionGroupById(openDeleteModal.id)

      const existError = response?.errors
      setOpenSnackbar((prev) => ({
        ...prev,
        open: true,
        message: existError ? handleAllErrors(existError?.[0]?.code ?? '', t, 'optionGroup.modal.delete.error') : t('optionGroup.modal.delete.success'),
        type: existError ? Types.ERROR : Types.SUCCESS,
      }))
      closeDeleteModal()
      if (!existError) {
        getAll()
      }
    }
  }
  const getItem = async (id: number) => {
    setIsLoading(true)
    const response: OptionGroupList = await OptionGroupService(httpFetch).getOptionGroupById(id)

    if (!response?.errors) {
      setId(id)
      setData({
        title: response.title,
        options:
          response.options?.length > 0
            ? response.options?.map((item, index) => ({
              description: item.description,
              iconUrl: item.iconUrl,
              id: index + 1,
            }))
            : initialData.options,
        optionId: response.options?.length || 2,
      })
      handleGoFrom(true)
    }
    setIsLoading(false)
  }

  const getAll = async () => {
    setIsLoading(true)
    const responseStores = await getList(colors, t,returnQuery({ ...filterMain.query, filter: filterMain.query.filter?.replaceAll('+', '%2B') }))
    setInputs((prev) => ({
      ...prev,
      createYear: {
        ...prev.createYear,
        items: getPreviousYears().map((e) => ({
          label: e?.label,
          value: e?.value,
        })),
      },
      month: {
        ...prev.month,
        items: monthYear.map((e) => ({
        ...e,
        value: e.value + 1,
      })),
      },
    }))
    const row = responseStores.row.map((item: any) => ({
      ...item,
      action: {
        children: (
          <Box sx={styles.constainerAction}>
            <Tooltip title={t('ToolTips.edit')}>
              <IconButton
                sx={styles.edit}
                onClick={(e) => {
                  e.stopPropagation()
                  getItem(item.id)
                }}
              >
                {icons('edit')}
              </IconButton>
            </Tooltip>
            <Tooltip title={t('ToolTips.delete')}>
              <IconButton
                sx={styles.delete}
                onClick={(e) => {
                  e.stopPropagation()
                  setOpenDeleteModal({
                    open: true,
                    id: item.id,
                  })
                }}
              >
                {icons('delete')}
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    }))

    setTotalPages(responseStores.totalPages)
    setTable(row)
    setIsLoading(false)
    setData(initialData)
    handleGoFrom(false)
  }

  const handleGoFrom = (go: boolean) => {
    setGoForm(go)
    if (!go) {
      setId(null)
      setData(initialData)
      setAllErrors({})
      setOpenSnackbar((prev) => ({
        ...prev,
        openModal: false,
      }))
    }
  }

  const closeDeleteModal = () => {
    setOpenDeleteModal({
      id: null,
      open: false,
    })
  }
  const handleDisabled = () => !data.title || !!data.options?.find((item: ModelOption) => !item.description)
  useEffect(() => {
    if (refTime.current) { clearTimeout(refTime.current) }

    refTime.current = setTimeout(() => {
      getAll()
    }, 300)
  }, [filterMain.query.all])

  return (
    <Box sx={styles.container}>
      <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} time={3000} />
      <SnackSimple
        close={downloadMain.closeOpenSnakbar}
        open={downloadMain.openSnackbar.open}
        type={downloadMain.openSnackbar.type as Types}
        message={downloadMain.openSnackbar.message}
      />
      <BreadCrumb
        removeBreadcrumb={['setting']}
        replaceLabels={{ 'option-group': 'settingOptionGroup' }}
      />
      <SimpleModal
        open={openSnackbar.openModal}
        description=""
        close={() => {
          handleGoFrom(false)
        }}
        title={openSnackbar.message}
        buttonText={t('general.yes')}
        cancelText={t('general.no')}
        color={colors}
        back={() => {
          handleGoFrom(false)
        }}
        loadingButton
        isLoading={btnLoading}
        next={() => {
          handleSubmit(true)
        }}
      />
      <SimpleModal
        open={openDeleteModal.open}
        description={t('optionGroup.modal.delete.description')}
        close={closeDeleteModal}
        title={t('optionGroup.modal.delete.title')}
        buttonText={t('general.delete')}
        cancelText={t('general.cancel')}
        color={colors}
        back={closeDeleteModal}
        loadingButton
        isLoading={btnLoading}
        next={() => {
          handleDelete()
        }}
      />
      {!goForm ? (
        <Box sx={{ position: 'relative', paddingRight: '50px' }}>
          <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={0} top={0}>
            <Box sx={styles.section}>
              <DinamicForm errors={errors} input={Object.values(inputs)} values={filterData} onChange={onChange} filter={true} />
            </Box>
          </FiltersDrawer>

          <Box sx={styles.header}>
            <Typography variant='title_grey_big'>{t('optionGroup.filter.title')}</Typography>

            <Box sx={styles.flex}>
              <ModelDownloadButtons
                csv={downloadMain.downloadCSV}
                pdf={downloadMain.downloadPDF}
                word={downloadMain.downloadWORD}
                disableCSV={downloadMain.download.excel}
                disablePDF={downloadMain.download.pdf}
                disableWORD={downloadMain.download.word}
                styleType
              />

              <Tooltip title={t('ToolTips.clearFilters')}>
                <IconButton
                  sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                  onClick={() => {
                    cleanFilter()
                  }}
                >
                  {icons('clean')}
                </IconButton>
              </Tooltip>

              <Tooltip title={t('ToolTips.create')}>
                <IconButton
                  sx={styles.clean}
                  className='add'
                  onClick={() => {
                    handleGoFrom(true)
                  }}
                >
                  {icons('add')}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <CustomTable
            loader={isLoading}
            color={colors}
            column={column}
            row={table}
            selected={-1}
            order={
              query.sort && {
                count: query?.sort?.count,
                key: query?.sort?.field,
                order: query?.sort?.sort,
              }
            }
            sortable={(field, sort, count) => {
              sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
            }}
            serverSidePagination={{
              page: (paginationModel.page ?? 0) + 1,
              size: paginationModel?.pageSize ?? 20,
              totalPages: totalPages,
            }}
            handleChange={(page: number, pageSize: number) => {
              handlePagination({ page, pageSize })
            }}
          />
        </Box>
      ) : (
        <Form
          t={t}
          id={id}
          color={colors}
          input={Object.values(initialValues)}
          goBack={() => {
            handleGoFrom(false)
          }}
          data={data}
          btnLoading={btnLoading}
          loading={isLoading}
          crudChange={crudChange}
          options={Object.values(option)}
          addOption={addOption}
          allErrors={allErrors}
          disabled={handleDisabled()}
          submit={(send) => {
            if (send > 0) {
              handleSubmit()
            }
          }}
        />
      )}
    </Box>
  )
}

export default OptionGroup
